import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popup__content payout-rules" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "popup__controls" }
const _hoisted_4 = { class: "text-capitalize-first" }
const _hoisted_5 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderButton = _resolveComponent("LoaderButton")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    "hide-title": true,
    onOnClose: _ctx.hide
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          src: require('@/apps/public/assets/img/payout-rules.png'),
          class: "payout-rules__img",
          alt: ""
        }, null, 8, _hoisted_2)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
          class: "btn popup__close"
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.helper.trans('button.cancel')), 1)
        ]),
        _createVNode(_component_LoaderButton, {
          "on-click": _ctx.onAcceptClick,
          class: "btn btn--accept"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.helper.trans('button.i_accept')), 1)
          ]),
          _: 1
        }, 8, ["on-click"])
      ])
    ]),
    _: 1
  }, 8, ["onOnClose"]))
}